export const englishWords = {
  T_dashboard_1: "Today's active workshops",
  T_dashboard_2: "Workshops Status Count",
  T_dashboard_3: "Workshops Per Providers",
  T_dashboard_4: "Mandays per venue",
  T_dashboard_employee_attendance: "Attendnace percentage",
  T_dashboard_5: "Top 10 Subjects",
  T_dashboard_6: "Mandays Per Month And Year",
  T_dashboard_7: "Workshop attendance per department",
  T_add_invitation:'Add Invitation',
  T_dashboard_8: "Attendees Count",
  T_dashboard_9: "Total Count",
  T_dashboard_vendor_1: "Topics per vendor",
  T_dashboard_vendor_2: "Workshop Count Per Vendor",
  T_dashboard_vendor_3: "Total Mandays Per Vendor",
  T_dashboard_vendor_4: "Attendance Average Per Vendor",
  T_dashboard_vendor_5: "Total Mandays Per Vendor and Modality",
  T_dashboard_vendor_6: "Mandays Per Location",
  T_dashboard_vendor_7: "Virtual",
  T_dashboard_vendor_8: "Physical",
  T_trainer_dashboard_1: "Workshops By Topic",
  T_trainer_dashboard_2: "Workshops by Status",
  T_vendor_dashboard_1: "Workshops By Location",
  T_vendor_dashboard_2: "Workshops by Company",
  T_vendor_dashboard_3: "Workshops by Topic",
  T_vendor_dashboard_4: "Workshops by Trainer",
  T_vendor_dashboard_5: "Workshops by Language",
  T_vendor_dashboard_6: "Top 5 Subjects",
  T_is_active: "Active",
  T_is_locked: "Is locked",
  T_start_date: "Start date",
  T_end_date: "End date",
  T_login: "Login",
  T_logout: "Logout",
  T_already_have_account: "Already have an account? Login",
  T_register_new_account: "Register New Account",
  T_login_or_register_to_enroll: "Please login or register to enroll in this workshop",
  T_search: "Search",
  T_registration_number: "Registration Number",
  T_enter_registration_number:"Enter Registration Number",
  T_countries: "Countries",
  T_cities: "Cities",
  T_calender: "Calender",
  T_enrolled_calender: "Enrolled Calender",
  T_vendors: "Vendors",
  T_select_vendor: "Select Vendor",
  T_trainers: "Trainers",
  T_trainer_bio: "Trainer Biography",
  T_consolidation: "Consolidation",
  T_select_trainer: "Select Trainer",
  T_venus: "Venues",
  T_select_venus: "Select Venue",
  T_users: "Users",
  T_competencies: "Competencies",
  T_select_competencies: "Select Competencies",
  T_approved:'Approved',
  T_no_data_selected: "No Data Selected",
  T_welcome:'Welcome',
  T_topics: "Topics",
    T_topic_name: "Topic Name",
  T_select_topics: "Select Topic",
  T_select_companies: "Select Companies",
  T_gender: "Gender",
  T_permissions_list: "Permissions List",
  T_back: "Back",
  T_back_to_roles: "Back to Roles",
  T_print: "Print",
  T_workshops: "Workshops",
  T_workshop_title: "Workshops Title",
  T_workshop_details: "Workshop Details",
  T_workshops_group: "Workshops Group",
  T_add_workshops_group: "Add Workshops Group",
  T_departments: "Departments",
  T_company_topics: "Company Topics",
  T_company_vendors: "Company Vendor",
  T_trainees_evolution: "Trainees Evaluation",
  T_jobs: "Jobs",
  T_approve:"Approve",
  T_reject:"Reject",
  T_job: "Job",
  T_job_Ar: "Job Ar",
  T_roles: "Roles",
  T_name: "Name",
  T_country: "Country",
  T_withdrawalDeadline:"Withdrawal Deadline (days)",
  T_timeToComplete:"time To Complete",
  T_name_Ar: "Name Ar",
  T_action: "Actions",
  T_accept: "Accept",
  T_country_code: "Country Code",
  T_enter_country_code: "Enter Country Code",
  T_country_name: "Country name",
  T_country_name_Ar: "Country name Ar",
  T_Logo: "Logo",
  T_certificate_name: "Certificate Name",
  T_enter_certificate_name: "Enter Certificate Name",
  T_title: "Title",
  T_internal_id: "Internal ID",
  T_info: "Info",
  T_colors: "Colors",
  T_info_1: "User Name",
  T_info_2: "Email",
  T_info_3: "Phone Number",
  T_info_4: "preferred language",
  T_title_Ar: "Title Ar",
  T_company_competencies: "Company Competencies",
  T_corporate_competencies: "Corporate Competencies",
  T_corporate_topics: "Corporate Topics",
  T_corporate_vendors: "Corporate Vendors",
  T_enter_title: "Enter Title",
  T_description: "Description",
  T_description_Ar: "Description Ar",
  T_enter_description: "Enter Description",
  T_drop_file: 'Drag "n" drop some files here, or click to select files',
  T_per_page: "Per Page",
  T_add_country: "Add Country",
  T_edit_country: "Edit Country",
  T_delete_country: "Delete Country",
  T_enter_name: "Enter Name",
  T_enter_country_name: "Enter Country Name",
  T_enter_code: "Enter Code",
  T_add: "Add",
  T_clear: "Clear",
  T_save: "Save",
  T_cancel: "Cancel",
  T_company: "Company",
  T_companies_included: "Companies Included",
  T_code: "Code",
  T_edit: "Edit",
  T_delete: "Delete",
  T_details: "Details",
  T_delete_country_confirm: "Are you sure you want to delete this country?",
  T_delete_companyTopic_confirm:
    "Are you sure you want to delete this company topic?",
  T_add_city: "Add City",
  T_add_venue: "Add Venue",
  T_add_user: "Add User",
  T_modalities: "Modalities",
  T_cohost: "Cohost",
  T_reset: "Reset",
  T_unfinish: "Unfinish",
  T_close: "Close",
  T_proficiency_level: "Proficiency Level",
  T_select_proficiency_level: "Select Proficiency Level",
  T_select_modalities: "Select Modalities",
  T_add_department: "Add Department",
  T_add_competency: "Add Competency",
  T_edit_competency: "Edit Competency",
  T_delete_competency: "Delete Competency",
  T_competency: "Competency",
  T_department: "Department",
  T_department_Ar: "Department Ar",
  T_add_topic: "Add Topic",
  T_edit_topic: "Edit Topic",
  T_edit_department: "Edit Department",
  T_edit_user: "Edit User",
  T_edit_venue: "Edit Venue",
  T_edit_city: "Edit City",
  T_delete_topic: "Delete Topic",
  T_delete_topic_confirm: "Are you sure you want to delete this topic?",
    T_delete_language: "Delete Language",
  T_delete_language_confirm: "Are you sure you want to delete this language?",
  T_delete_city: "Delete City",
  T_delete_department: "Delete Department",
  T_delete_city_confirm: "Are you sure you want to delete this city?",
  T_delete_vendor_confirm: "Are you sure you want to delete this vendor?",
  T_delete_department_confirm:
    "Are you sure you want to delete this department?",
  T_city: "City",
  T_companies: "Companies",
  T_add_vendor: "Add Vendor",
  T_edit_vendor: "Edit Vendor",
  T_delete_vendor: "Delete Vendor",
  T_parameters: "Parameters",
  T_add_parameter: "Add Parameter",
  T_edit_parameter: "Edit Parameter",
  T_delete_parameter: "Delete Parameter",
  T_delete_parameter_confirm: "Are you sure you want to delete this parameter?",
  T_no_parameters: "No Parameters",
  T_no_parameters_message: "No parameters found",
  T_value: "Value",
  T_enter_value: "Enter Value",
  T_updated_on: "Updated On",
  T_update: "Update",
  T_biography: "Biography",
  T_last_name: "Last Name",
  T_first_name: "First Name",
  T_middle_name: "Middle Name",
  T_longitude: "Longitude",
  T_latitude: "Latitude",
  T_learning_outcome: "Learning Outcome",
  T_attended_list: "Attendees List",
  T_no_attended_list: "No Attended List",
  T_no_attended_list_message: "There are no Attended List available",
  T_no_invitation_list: "No invitation List",
  T_no_invitation_list_message: "There are no invitation List available",
  T_waiting_list: "Waiting List",
  T_no_waiting_list: "No Waiting List",
  T_waiting_list_message: "There are no Waiting List available",
  T_enter_longitude: "Enter Longitude",
  T_enter_latitude: "Enter Latitude",
  T_enter_biography: "Enter Biography",
  T_enter_last_name: "Enter Last Name",
  T_enter_first_name: "Enter First Name",
  T_enter_middle_name: "Enter Middle Name",
  T_add_trainer: "Add Trainer",
  T_hod:'Head Of Department',
  T_hod_ar:'Head Of Department Ar',
  T_approving_officer:'Approving Officer',
  T_approving_officer_ar:'Approving Officer Ar',
  T_edit_trainer: "Edit Trainer",
  T_phone_number: "Phone Number",
  T_email: "Email",
  T_import: "Import",
  T_create_link: "Create Registration Link",
  T_create_link_success:"Registration link copied successfully!",
  T_download_template: "Download Template",
  T_final_score: "Final Score",
  T_note: "Note",
  T_note_title: "Note Title",
  T_note_title_ar: "Note Title ar",
  T_username: "Username",
  T_enter_phone_number: "Enter Phone Number",
  T_enter_email: "Enter Email",
  T_enter_username: "Enter Username",
  T_select_city: "Select City",
  T_to_date: "To Date",
  T_added_date: "Added Date",
  T_from_date: "From Date",
  T_from_time: "From Time",
  T_to_time: "To Time",
  T_link: "Link",
  T_provider: "Provider",
  T_status: "Status",
  T_workshop_progress: "Workshop Progress",
  T_minute:'minute',
  T_enter_link: "Enter Link",
  T_capacity: "Capacity",
  T_enter_capacity: "Enter Capacity",
  T_room_number: "Room Name/Number",
  T_enter_room_number: "Enter Room Number",
  T_topic_number: "Topic Number",
  T_vendor_name: "Vendor Name",
  T_venue_name: "Venue Name",
  T_company_name: "Company Name",
  T_type:"Type",
  T_file_size: "Max file size: 2.5 MB",
  T_delete_venue: "Delete Venue",
  T_delete_companyDepartment: "Delete Company Department",
  T_delete_companyJob: "Delete Company Job",
  T_delete_companyTopic: "Delete Company Topic",
  T_role_name: "Role Name",
  T_back_to_workshops: "Back To Workshops",
  T_back_to_workshop_details: "Back To Workshop Details",
  T_enter_role_name: "Enter Role Name",
  T_delete_trainer: "Delete Trainer",
  T_delete_venue_confirm: "Are you sure you want to delete this Venue?",
  T_delete_permission_confirm:
    "Are you sure you want to delete this Permission?",
  T_delete_trainer_confirm: "Are you sure you want to delete this trainer?",
  T_delete_employee_confirm: "Are you sure you want to delete this employee?",
  T_delete_competency_confirm:
    "Are you sure you want to delete this competency?",
  T_add_job: "Add Job",
  T_select_status: "Select Status",
  T_edit_job: "Edit Job",
  T_delete_job: "Delete Job",
  T_delete_company: "Delete Company",
  T_delete_company_confirm: "Are you sure you want to delete this Company?",
  T_delete_job_confirm: "Are you sure you want to delete this job?",
  T_delete_companyDepartment_confirm:
    "Are you sure you want to delete this Company Department?",
  T_delete_companyJob_confirm:
    "Are you sure you want to delete this Company Job?",
  T_add_workshop: "Add Workshop",
  T_delete_workshop: "Delete Workshop",
  T_delete_workshop_confirm: "Are you sure you want to delete this Workshop?",
  T_delete_workshop_evaluation_confirm: "Are you sure you want to delete this Workshop Evaluation?",
  T_add_workshop_group: "Add Workshop Group",
  T_edit_workshop_group: "Edit Workshop Group",
  T_delete_workshop_group: "Delete Workshop Group",
  T_delete_workshop_group_confirm: "Are you sure you want to delete this Workshop group?",
  T_delete_workshop_invitation: "Delete Workshop Invitation",
  T_approve_workshop: "Approve Workshop",
  T_reject_workshop: "Reject Workshop",
  T_edit_workshop: "Edit Workshop",
  T_delete_workshop_invitation_confirm: "Are you sure you want to delete this Workshop Group Invitation ?",
  T_approve_workshop_confirm: "Are you sure you want to Approve this Workshop?",
  T_reject_workshop_confirm: "Are you sure you want to Reject this Workshop?",
  T_no_company_header: "No Companies Found",
  T_no_industry_header: "No Industries Found",
  T_no_industry_message: "There are no Industries available",
  T_no_company_message: "There are no Companies available",
  T_no_city_header: "No Cities Found",
  T_no_city_message: "There are no Cities available",
  T_no_country_header: "No Countries Found",
  T_no_assessments:"No Assessment",
  T_no_country_message: "There are no Countries available",
  T_no_vendor_header: "No Vendors Found",
  T_no_vendor_message: "There are no Vendors available",
  T_no_venue_header: "No Venues Found",
  T_no_venue_message: "There are no Venues available",
  T_full_control: "Full Control",
  T_read: "Read",
  T_modify: "Modify",
  T_no_training_header: "No Trainers Found",
  T_reg: "Registrations Number",
  T_no_training_message: "There are no Trainers available",
  T_date: "Date",
  T_dob: "Date of birth",
  T_no_option_header:"No Options Found",
  T_no_option_message:"There are no Options available",
  T_no_user_header: "No Users Found",
  T_no_user_message: "There are no Users available",
   T_no_question_header: "No Questions Found",
  T_no_question_message: "There are no Questions available",
  T_no_competency_header: "No Competencies Found",
  T_no_competency_message: "There are no Competencies available",
  T_no_topic_header: "No Topics Found",
  T_no_topic_message: "There are no Topics available",
  T_no_workshop_header: "No Workshops Found",
  T_no_workshop_message: "There are no Workshops available",
  T_copy_link: "Copy Link To Share With Providers",
  T_no_department_header: "No Departments Found",
  T_no_department_message: "There are no Departments available",
  T_submit_changes: "Submit Changes",
  T_no_changes: "No Changes",
  T_pretest: "Is Pre Test",
  T_is_pretest: "Is Pre Test ?",
  T_posttest: "Post Test",
  T_is_posttest: "Is Post Test ?",
  T_is_certifiedtest: "Is Certified Test ?",
  T_is_psychometrictest: "Is Psychometric Test ?",
  T_finalscore: "Final Score",
  T_no_job_header: "No Jobs Found",
  T_no_job_message: "There are no Jobs available",
  T_no_prof_header: "No Proficiency Levels Found",
  T_no_prof_message: "There are no Proficiency Levels available",
  T_no_role_header: "No Roles Found",
  T_permissions: "Permissions",
  T_no_role_message: "There are no Roles available",
  T_time:'Time',
  T_employee_id: "Employee Id",
  T_residence_country: "Country of Residence",
  T_select_residence_country: "Select Residence Country",
  T_select_job: "Select a job",
  T_employee_sheet: "Employee Sheet",
  T_enter_employee_id: "Enter Employee Id",
  T_profile_picture: "Profile Picture",
  T_employees: "Employees",
  T_permission_name: "Permission Name",
  T_permission_description: "Permission Description",
  T_evaluation_from_date:"Evaluation From Date",
  T_evaluation_to_date:"Evaluation To Date",
  T_select_evaluation:"Select Evaluation",
  T_tests: "Tests",
  T_attendance: "Attendance",
  T_certificates: "Certificates",
  T_not_eligible_for_certificate: "You are not eligible to download the certificate yet.",
  T_certificate_download_failed: "Failed to download certificate.",
  T_certificate_download_success: "Certificate downloaded successfully.",
  T_missing_employee_id: "Unable to determine your employee identifier.",
  T_assignments: "Assignments",
  T_polls: "Polls",
  T_material: "Material",
  T_add_employee: "Add Employee",
  T_in_arabic: "in Arabic",
  T_select_department: "Select a department",
  T_select_date: "Select Date",
  T_customTitle: "Custom Title",
  T_customTitle_Ar: "Custom Title Arabic",
  T_company_departments: "Company Departments",
  T_department_name: "Department name",
  T_no_employee_header: "ُNo employees found",
  T_no_employee_message: "ُNo employees available",
  T_Profile: "Profile",
  T_send_notifications:'Send Notification',
  T_edit_company: "Edit Company",
  T_company_jobs: "Company Jobs",
  T_company_job_competencies: "Job Competencies",
  T_competency_name: "Competency Name",
  T_no_company_jobs_competencies_header: "No Competencies",
  T_no_company_jobs_competencies_message:
    "No competencies for the selected job",
    T_no_language_header: "No Languages",
  T_no_language_message:
    "No languages available",
  T_add_permission: "Add Permission",
  T_edit_permission: "Edit Permission",
  T_delete_permission: "Delete Permission",
  T_system_parameters: "System Parameters",
  T_dashboard: "Dashboard",
  T_security: "Security",
  T_filter_calender:'Filter',
  T_filter_workshops:'Filter',
  T_workshop_invitations_list: "Invitation List",
  T_created_on: "Created On",
  T_acquired_competencies: "Acquired Competencies",
  T_send_invitations: "Send Invitations",
  T_acquire_source: "Acquisition Source",
  T_verified: "Verified?",
  T_add_role: "Add Role",
  T_delete_role: "Delete Role",
  T_delete_role_confirm: "Are you sure you want to delete this Role?",
  T_employee_competencies: "Employee Competencies",
  T_no_employee_competency_header: "No competencies",
  T_no_employee_topic: "No Topic",
  T_no_employee_topic_message: "No Topic Found ",
  T_no_permissions: "No Permissions",
  T_no_permissions_message: "No Permissions Found",
  T_import_from_master: "Import From Master",
  T_no_employee_employees: "No Employees",
  T_no_employee_employees_message: "No Employees Found",
  T_add_company: "Add Company",
  T_no_employee_competency_message:
    "No competencies found for the selected employee",
  T_evaluation: "Evaluation",
  T_attendance_count: "Attendance Percentage",
  T_average_attendance: "Average Attendance Percentage",
  T_average_pretest_score: "Average Pretest Score",
  T_industry_name: "Industry Name",
  T_edit_role: "Edit Role",
  T_industry_name_Ar: "Industry Name in Arabic",
  T_average_posttest_score: "Average Posttest Score",
  T_average_final_score: "Average Final Score",
  T_withdraw: "Withdraw",
  T_hello: "Hello",
  T_default_name: "Default Name",
  T_edit_sms: "Edit SMS",
  T_sms_1: "Twilio Account Sid",
  T_sms_2: "twilio Auth Token",
  T_sms_3: "twilio From Sender Name",
  T_sms_4: "twilio Whatsapp From Mobile",
  T_edit_smtp: "Edit SMTP",
  T_smtp_1: "SMTP Host",
  T_smtp_2: "SMTP Port",
  T_smtp_3: "SMTP User Name",
  T_smtp_4: "SMTP Password",
  T_smtp_5: "SMTP From Email",
  T_edit_colors: "Edit Colors",
  T_colors_1: "Add Update Icon Color",
  T_colors_2: "Add Update Icon Hover Color",
  T_colors_3: "Cancel Button Color",
  T_colors_4: "Cancel Button Hover Color",
  T_colors_5: "Chart Main Color",
  T_colors_6: "Delete Icon Color",
  T_colors_7: "Delete Icon Hover Color",
  T_colors_8: "Label Color",
  T_colors_9: "Menu Bg Color",
  T_colors_10: "Menu Item Hover Color",
  T_colors_11: "MenuItem Selected Color",
  T_colors_12: "View Icon Color",
  T_colors_13: "View Icon Hover Color",
  T_custom_name: "Custom Name",
  T_default_name_ar: "Default Name in Arabic",
  T_number_workshops: "Number of Workshops",
  T_number_enrollments: "Number Of Enrollments",
  T_number_evaluations: "Number Of Evaluations",
  T_custom_name_ar: "Custom Name in Arabic",
  T_rank: "Rank",
  T_company_proficiency_levels: "Proficiency Levels",
  T_edit_proficiency_level: "Edit Proficiency Level",
  T_add_proficiency_level: "Add Proficiency Level",
  T_delete_proficiency_level: "Delete Proficiency Level",
  T_delete_proficiency_level_confirm: "Are you sure you want to delete this Proficiency Level",
  T_title_ar: "Title in Arabic",
  T_active: "Active",
  T_created_date: "Created Date",
  T_workshop_evaluation: "Workshop Evaluation",
  T_workshop_evaluation_question_dimensions: "Evaluation Question Dimensions",
  T_description_ar: "Description in Arabic",
  T_edit_industry: "Edit Industry",
  T_delete_industry: "Delete Industry",
  T_delete_industry_confirm: "Are you sure you want to delete this Industry?",
  T_add_industry: "Add Industry",
  T_dimension: "Dimension",
  T_question_order: "Question Order",
  T_number_of_questions:"Number of questions",
  T_questions: "Questions",
  T_order: "Order",
  T_workshop_evaluation_question: "Evaluation Question",
  T_workshop_evaluation_question_options: "Evaluation Question Options",
  T_score: "Score",
  T_add_question: "Add Question",
  T_edit_question: "Edit Question",
  T_delete_question: "Delete Question",
  T_delete_question_confirm: "Are you sure you want to delete this Question?",
  T_enter_order: "Enter Order",
  T_select_type: "Select Type",
  T_add_evaluation_question_dimension: "Add Evaluation Question Dimension",
  T_edit_evaluation_question_dimension: "Edit Evaluation Question Dimension",
  T_delete_evaluation_question_dimension: "Delete Evaluation Question Dimension",
  T_delete_evaluation_question_dimension_confirm: "Are you sure you want to delete this Question Dimension",
  T_vendor_assessment_definition: "Assessment Definitions",
  T_assessment_level: "Assessment Level",
  T_assessment: "Assessment",
  T_assessment_result: "Assessment Result",
  T_select_assessment: "Select Assessment",
  T_detailed_scores: "Detailed Scores",
  T_trainer_name:'Trainer Name',
  T_attendance_frequency:'Attendance Frequency',
  T_rejection: "Rejection Reason",
  T_enrolled: "Enrolled",
  T_completed: "Completed",
  T_upcoming: "Open workshops",
  T_invitation: "Invitation",
  T_clone:'Clone',
  T_enroll: "Enroll",
  T_show_assessment: "Show Assessment",
  T_addition: "Addition",
  T_eligibleForCertificate: "Eligible for Certificate",
  T_employee: "Employee",
  T_involvement: "Involvement",
  T_posttestScore: "Posttest Score",
  T_pretestScore: "Pretest Score",
  T_evaluationScore: "Evaluation Score",
  T_employeeGrades: "Employee Grades",
  T_grading: "Grading",
  T_languages: "Languages",
  T_add_language: "Add Language",
  T_certifying_bodies: "Certifying Bodies",
  T_certifying_body: "Certifying Body",
  T_add_certifying_body: "Add Certifying Body",
  T_edit_certifying_body: "Edit Certifying Body",
  T_delete_certifying_body: "Delete Certifying Body",
  T_delete_certifying_body_confirm: "Are you sure you want to delete this Certifying Body?",
  T_no_certifying_bodies: "No Certifying Bodies",
  T_select_languages: "Select Languages",
  T_vendor_assessment_type: "Assessment Types",
  T_vendor_assessment_questions: "Assessment Questions",
  T_vendor_assessment_workshops: "Assessment Workshops",
  T_vendor_assessment_question_options: "Assessment Questions Options",
  T_add_vendor_assessment_question_option: "Add Assessment Question Options",
  T_edit_vendor_assessment_question_option: "Edit Assessment Question Options",
  T_delete_vendor_assessment_question_option: "Delete Assessment Question Options",
  T_delete_vendor_assessment_question_option_confirm: "Are You sure you want to delete this Question Options?",
  T_no_vendor_assessment_questions: "No Assessment Questions",
  T_add_vendor_assessment_type: "Add Assessment Type",
  T_edit_vendor_assessment_type: "Edit Assessment Type",
  T_delete_vendor_assessment_type: "Delete Assessment Type",
  T_delete_vendor_assessment_type_confirm: "Are you sure you want to delete this Assessment Type ?",
  T_prerequisite: "Prerequisite",
  T_enter_prerequisite: "Enter Prerequisite",
  T_workshop_assessments: "Workshop Assessments",
  T_add_workshop_assessment: "Add Workshop Assessment",
  T_add_assessment: "Add Assessment",
  T_edit_assessment: "Edit Assessment",
  T_delete_assessment: "Delete Assessment",
  T_delete_assessment_Confirm: "Are you sure you want to delete this Assessment?",
  T_edit_workshop_assessment: "Edit Workshop Assessment",
  T_delete_workshop_assessment: "Delete Workshop Assessment",
  T_delete_workshop_assessment_confirm: "Are you sure you want to delete this Workshop Assessment?",
  T_time_to_complete : "Time to Complete (min)",
  T_minutes: "minutes",
  T_no_evaluation: "No Evaluation",
  T_no_evaluation_message: "No evaluation found for this workshop",
  T_requires_invitation:'Requires invitation',
  T_corporate: 'Corporate',
  T_is_corporate: 'Is it Corporate ?',
  T_add_to_waiting_list: 'Add me to waiting list',
  T_employee_name: 'Employee Name',
  T_send_vouchers: 'Send Vouchers',
  T_vouchers: 'Vouchers',
  T_voucher_code: 'Voucher Code',
  T_expiry_date: 'Expiry Date',
  T_is_used: 'Is Used',
  T_view_details: 'View Details',
  T_sending: 'Sending...',
  T_no_employees: 'No employees found',
  T_startedOn: 'Started On',
  T_elapsedTime: 'Elapsed Time',
  T_yes: "Yes",
  T_no: "No",
  T_questions_answered: "Questions Answered",
  T_questionAnswered: 'Questions Answered',
  T_monitorAssessment: 'Monitor Assessment',
  T_monitor: 'Monitor',
  T_download_all_cetficates: 'Download Certificates',
  T_SwitchRole: 'Switch Role',
  T_SwitchEntity: 'Switch Company',
  T_reports: "Reports",
  T_score_data: "Score Data",
  T_evaluation_data: "Evaluation Data",
  T_more_actions: "More Actions",
  T_questions_analysis_report: "Questions Analysis Report",
  T_pretest_grades_report: "Pre-Test Grades Report",
  T_pretest_analysis_report: "Pre-Test Analysis Report",
  T_workshop_excel_report: "Workshop Summary Excel",
  T_workshop_excel_report_success: "Workshop summary report downloaded successfully.",
  T_workshop_excel_report_failed: "Failed to download workshop summary report.",
  T_workshop_report_pdf: "Workshop Report",
  T_workshop_report_success: "Workshop report downloaded successfully.",
  T_workshop_report_failed: "Failed to download workshop report.",
  T_attendees_chronological_report_excel: "Attendees List Report (Excel)",
  T_attendees_chronological_report_pdf: "Attendees List Report (PDF)",
  T_attendees_chronological_report_success: "Attendees chronological report downloaded successfully.",
  T_attendees_chronological_report_failed: "Failed to download attendees chronological report.",
  T_questions_list: "Questions List",
  T_download: "Download",
  T_downloading: "Downloading...",
  T_workshops_per_client: "Workshops Per Client",
  T_select_company: "Select Company",
  T_select: "Select",
  T_discount: "Discount",
  T_voucher_discount: "Voucher Discount",
  T_all: "All",
  T_generate_report: "Generate Report",
  T_export_excel: "Export to Excel",
  T_export_pdf: "Export to PDF",
  T_export_to_excel: "Export to Excel",
  T_export_success: "Data exported successfully",
  T_no_data_to_export: "No data available to export",
  T_topic: "Topic",
  T_trainer: "Trainer",
  T_pretest_average: "Pretest Average",
  T_posttest_average: "Posttest Average",
  T_evaluation_average: "Evaluation Average",
  T_enrollment_count: "Enrollment Count",
  T_enrollment_list: "Enrollment List",
  T_no_data_available: "No data available",
  T_workshop_photos: "Workshop Photos",
  T_workshop_enrollment: "Workshop Enrollment",
  T_venue: "Venue",
  T_available_seats: "Available Seats",
  T_enroll_now: "Enroll Now",
  T_enrolling: "Enrolling...",
  T_already_enrolled: "You are already enrolled in this workshop",
  T_go_to_dashboard: "Go to Dashboard",
  T_go_to_workshop: "Go to Workshop",
  T_enrollment_success: "Successfully enrolled in workshop",
  T_enrollment_error: "Error enrolling in workshop",
  T_error_fetching_workshop: "Error fetching workshop details",
  T_workshop_not_found: "Workshop not found",
  T_view_employee_workshops: "View Employee Workshops",
  T_employee_workshops: "Employee Workshops",
  T_no_workshops_found: "No workshops found for this employee",
  T_global_no_company: "Global (No Company)",
  T_optional: "Optional",
  T_back_to_assessments: "Back to Assessments",
  T_import_questions: "Import Questions",
  T_view_workshops: "View Workshops",
  T_view_workshop: "View Workshop",
  T_workshops_using_assessment: "Workshops Using Assessment",
  T_no_workshops_using_assessment: "No Workshops Found",
  T_no_workshops_using_assessment_message: "This assessment is not being used by any workshops yet",
  T_date_of_workshop: "Date of Workshop",
  T_workshop_name: "Workshop Name",
  T_pre_test_score: "Pre Test Score",
  T_post_test_score: "Post Test Score",
  T_evaluation_score: "Evaluation Score",
  T_attendance_percentage: "Attendance Percentage",
  T_certificate_link: "Certificate Link",
  T_none: "None"
};
export const arabicWords = {
  T_requires_invitation:'يتطلب دعوة',
  T_add_evaluation_question_dimension: "اضافة مقياس سؤال التقييم",
  T_questions: "السؤال",
  T_order: "ترتيب",
  T_enter_order: "ادخل الترتيب",
  T_select_type: "اختر النوع",
  T_add_question: "اضافة سؤال",
  T_add_invitation:'إضافة دعوة',
  T_score: "نقطة",
  T_workshop_evaluation_question_options: "خيارات السؤال",
  T_workshop_evaluation_question: "سؤال التقييم",
  T_type: "نوع",
  T_question_order: "ترتيب السؤال",
  T_dimension: "مقياس",
  T_add_industry: "اضافة صناعة",
  T_delete_industry_confirm: "هل تريد حذف هذه الصناعة؟",
  T_delete_industry: "حذف الصناعة",
  T_edit_industry: "تعديل الصناعة",
  T_dashboard_1: "ورش العمل النشطة اليوم",
  T_dashboard_2: "عدد حالات ورش العمل",
  T_dashboard_3: "ورش العمل لكل مزود",
  T_dashboard_4: "أيام العمل لكل مكان",
  T_dashboard_employee_attendance: "نسبة الحضور",
  T_dashboard_5: "أهم 10 مواضيع",
  T_dashboard_6: "أيام العمل لكل شهر وسنة",
  T_dashboard_7: "حضور ورش العمل لكل قسم",
  T_start_date: "تاريخ البدء",
  T_end_date: "تاريخ النهاية",
  T_dashboard_8: "عدد الحضور",
  T_dashboard_9: "العدد الإجمالي",
  T_dashboard_vendor_1: "المواضيع لكل مزود",
  T_dashboard_vendor_2: "عدد ورش العمل لكل مزود",
  T_dashboard_vendor_3: "إجمالي أيام العمل لكل مزود",
  T_dashboard_vendor_4: "متوسط الحضور لكل مزود",
  T_dashboard_vendor_5: "إجمالي أيام العمل لكل مزود ونوعيتها",
  T_dashboard_vendor_6: "أيام العمل لكل موقع",
  T_dashboard_vendor_7: "افتراضي",
  T_dashboard_vendor_8: "فعلي",
  T_trainer_dashboard_1: "ورش العمل حسب الموضوع",
  T_trainer_dashboard_2: "ورش العمل حسب الحالة",
  T_vendor_dashboard_1: "ورش العمل حسب الموقع",
T_vendor_dashboard_2: "ورش العمل حسب الشركة",
T_vendor_dashboard_3: "ورش العمل حسب الموضوع",
T_vendor_dashboard_4: "ورش العمل حسب المدرب",
T_vendor_dashboard_5: "ورش العمل حسب اللغة",
T_vendor_dashboard_6: "أهم 5 موضوعات",
  T_add_department: "إضافة قسم",
  T_edit_department: "قسم التحرير",
  T_delete_department: "حذف القسم",
  T_delete_department_confirm: "هل أنت متأكد أنك تريد حذف هذا القسم؟",
  T_add_job: "أضف الوظيفة",
  T_permissions: "الصلاحيات",
  T_add_role: "إضافة دور",
  T_edit_role: "تحرير الدور",
  T_delete_role: "حذف الدور",
  T_country: "بلد",
  T_delete_role_confirm: "هل أنت متأكد أنك تريد حذف هذا الدور؟",
  T_in_arabic: "بالعربية",
  T_edit_job: "تحرير الوظيفة",
  T_note_title: "عنوان الملاحظة",
  T_note_title_ar: "عنوان المذكرة باللغة العربية",
  T_delete_job: "حذف الوظيفة",
  T_enter_capacity: "أدخل القدرة",
  T_delete_job_confirm: "هل أنت متأكد أنك تريد حذف هذا الوظيفة",
  T_select_competencies: "حدد الكفاءات",
  T_login: "تسجيل",
  T_customTitle: "عنوان مخصص",
  T_customTitle_Ar: "عنوان مخصص بالعربية",
  T_logout: "خروج",
  T_already_have_account: "لديك حساب؟ تسجيل الدخول",
  T_register_new_account: "إنشاء حساب جديد",
  T_login_or_register_to_enroll: "يرجى تسجيل الدخول أو التسجيل للتسجيل في هذه الورشة",
  T_add_permission: "إضافة إذن",
  T_Profile: "حساب تعريفي",
  T_send_notifications:'إرسال الإخطار',
  T_add_company: "إضافة شركة",
  T_edit_permission: "تحرير إذن",
  T_average_attendance: "متوسط ​​نسبة الحضور",
  T_industry_name: "اسم الصناعة",
  T_industry_name_Ar: "اسم الصناعة بالعربية",
  T_delete_permission: "حذف إذن",
  T_tests: "الاختبارات",
  T_attendance: "الحضور",
  T_certificates: "الشهادات",
  T_not_eligible_for_certificate: "غير مؤهل لتنزيل الشهادة بعد.",
  T_certificate_download_failed: "فشل تنزيل الشهادة.",
  T_certificate_download_success: "تم تنزيل الشهادة بنجاح.",
  T_missing_employee_id: "تعذر تحديد معرف الموظف الخاص بك.",
  T_assignments: "الواجبات",
  T_polls: "الاستطلاعات",
  T_material: "المواد",
  T_enter_link: "أدخل الرابط",
  T_created_on: "تم الإنشاء في",
  T_search: "بحث",
  T_rejection: "سبب الرفض",
  T_number_workshops: "عدد الورش",
  T_number_enrollments: "عدد المسجلين",
  T_number_evaluations: "عدد التقييمات",
  T_employee_sheet: "ورقة الموظفين",
  T_edit_sms: "تعديل SMS",
  T_sms_1: "معرف حساب تويليو",
  T_sms_2: "رمز المصادقة الخاص تويليو",
  T_sms_3: "تويليو من اسم المرسل",
  T_sms_4: "واتساب تويليو من الجوال",
  T_edit_smtp: "تعديل SMTP",
  T_smtp_1: "مضيف SMTP",
  T_smtp_2: "منفذ SMTP",
  T_smtp_3: "اسم مستخدم SMTP",
  T_smtp_4: "كلمة مرور SMTP",
  T_smtp_5: "SMTP من البريد الإلكتروني",
  T_info_1: "اسم المستخدم",
  T_info_2: "بريد إلكتروني",
  T_add_workshop_group: "إضافة مجموعة ورشة عمل",
  T_edit_workshop_group: "مجموعة ورشة عمل التحرير",
  T_info_3: "رقم التليفون",
  T_info_4: "اللغة المفضلة",
  T_countries: "دول",
  T_average_pretest_score: "متوسط ​​درجات الاختبار الأولي",
  T_company_topics: "مواضيع الشركة",
  T_company_competencies: "كفاءات الشركة",
  T_cities: "مدن",
  T_clear: "حذف",
  T_company: "الشركة",
  T_delete_workshop_evaluation_confirm: "هل أنت متأكد أنك تريد حذف تقييم ورشة العمل هذه؟",
  T_vendors: "بائعين",
  T_company_vendors: "الشركة البائعة",
  T_average_posttest_score: "متوسط ​​درجات ما بعد الاختبار",
  T_average_final_score: "متوسط ​​النتيجة النهائية",
  T_select_vendor: "حدد البائع",
  T_phone_number: "رقم التليفون",
  T_trainer_name:'المدرب',
  T_delete_company: "حذف الشركة",
  T_edit_company: "تعديل الشركة",
  T_delete_company_confirm: "هل أنت متأكد أنك تريد حذف هذه الشركة",
  T_permission_name: "اسم الإذن",
  T_copy_link: "نسخ الرابط لمشاركته مع مقدمي الخدمة",
  T_permission_description: "وصف الإذن",
  T_edit_trainer: "تعديل المدرب",
  T_pretest: "اختبار أولي",
  T_is_pretest: "هل هو اختبار مسبق؟",
  T_topic_name: "اسم الموضوع",
  T_posttest: "اختبار ما بعد",
  T_is_posttest: "هل هو اختبار لاحق؟",
  T_is_certifiedtest: "هل هو اختبار معتمد؟",
  T_is_psychometrictest: "هل هو اختبار نفسي؟",
  T_no_data_selected: "لا توجد بيانات محددة",
  T_finalscore: "النتيجة النهائية",
  T_email: "بريد إلكتروني",
  T_username: "اسم المستخدم",
  T_date: "تاريخ",
  T_dob: "تاريخ الميلاد",
  T_select_venus: "اختر المكان",
  T_trainers: "مدربين",
  T_status: "الحالة",
  T_workshop_progress: "تقدم الورشة",
  T_select_status: "حدد الحالة",
  T_permissions_list: "قائمة الصلاحيات",
  T_back: "رجوع",
  T_back_to_roles: "العودة إلى الأدوار",
  T_print: "طباعة",
  T_enter_country_name: "أدخل اسم البلد",
  T_venus: "أماكن",
  T_users: "مستخدمين",
  T_note: "ملحوظة",
  T_attended_list: "قائمة الحضور",
  T_time:'وقت',
  T_no_attended_list: "لا توجد قائمة الحضور",
  T_no_attended_list_message: "لا توجد قائمة الحضور المتاحة",
  T_import_from_master: "استيراد من الرئيسي",
  T_waiting_list: "قائمة الانتظار",
  T_no_waiting_list: "لا توجد قائمة انتظار",
  T_delete_language: "حذف اللغة",
  T_delete_language_confirm: "هل أنت متأكد أنك تريد حذف هذه اللغة؟",
  T_waiting_list_message: "لا توجد قائمة انتظار متاحة",
  T_approve:"الموافقة",
  T_final_score: "النتيجة النهائية",
  T_longitude: "خط الطول",
  T_latitude: "خط العرض",
  T_edit_venue: "تعديل المكان",
  T_modalities: "أشكال",
  T_cohost: "المضيف المشارك",
  T_provider: "مزود",
  T_select_modalities: "حدد الطرائق",
  T_enter_longitude: "أدخل خط الطول",
  T_enter_latitude: "أدخل خط العرض",
  T_workshop_details: "تفاصيل الورشة",
  T_back_to_workshops: "العودة إلى ورش العمل",
  T_back_to_workshop_details: "العودة إلى تفاصيل ورشة العمل",
  T_select_trainer: "حدد المدرب",
  T_full_control: "تحكم كامل",
  T_read: "قراءة",
  T_modify: "تعديل",
  T_enter_room_number: "أدخل رقم الغرفة",
  T_details: "تفاصيل",
  T_competencies: "كفاءات",
  T_topics: "مواضيع",
  T_approved:'موافقة',
  T_delete_topic: "حذف الموضوع",
  T_delete_topic_confirm: "هل أنت متأكد أنك تريد حذف هذا الموضوع؟",
  T_from_time: "الوقت من",
  T_to_time: "الوقت ل",
  T_workshops: "ورش عمل",
  T_delete_workshops: "حذف ورش العمل",
  T_add_workshops_group: "إضافة مجموعة ورش العمل",
  T_workshops_group: "مجموعة ورش العمل",
  T_added_date: "تاريخ الإضافة",
  T_delete_trainer_confirm: "هل أنت متأكد أنك تريد حذف هذا المدرب؟",
  T_delete_employee_confirm: "هل أنت متأكد أنك تريد حذف هذا موظف",
  T_departments: "أقسام",
  T_department: "قسم",
  T_department_Ar: "قسم عربي",
  T_jobs: "وظائف",
  T_job_Ar: "وظائف عربي",
  T_companies: "الشركات",
  T_select_city: "اختر مدينة",
  T_roles: "أدوار",
  T_enter_description: "أدخل الوصف",
  T_enter_title: "أدخل عنوان",
  T_name: "اسم",
  T_name_Ar: "اسم عربي",
  T_delete_companyDepartment_confirm: "هل أنت متأكد أنك تريد حذف هذا القسم؟",
  T_delete_companyJob_confirm: "هل أنت متأكد أنك تريد حذف هذا الوظيفة؟",
  T_delete_companyTopic_confirm: "هل أنت متأكد أنك تريد حذف هذا الموضوع؟",
  T_action: "إجراءات",
  T_delete_trainer: "حذف المدرب",
  T_drop_file: "قم بسحب وإفلات بعض الملفات هنا، أو انقر لتحديد الملفات",
  T_country_code: "الرقم الدولي",
  T_dashboard: "لوحة القيادة",
  T_country_name: "اسم الدولة",
  T_country_name_Ar: "اسم الدولة عربي",
  T_Logo: "شعار",
  T_certificate_name: "اسم الشهادة",
  T_enter_certificate_name: "أدخل اسم الشهادة",
  T_submit_changes: "أرسل التغييرات",
  T_no_changes: "لا تغيرات",
  T_add_topic: "إضافة موضوع",
  T_edit_topic: "تحرير الموضوع",
  T_registration_number: "رقم التسجيل",
  T_enter_registration_number:"أدخل رقم التسجيل",
  T_add_competency: "أضف الكفاءة",
  T_edit_competency: "تحرير الكفاءات",
  T_info: "معلومات",
  T_colors: "الالوان",
  T_delete_competency: "حذف الكفاءة",
  T_delete_companyDepartment: "حذف قسم الشركة",
  T_learning_outcome: "مخرجات التعلم",
  T_delete_companyJob: "حذف وظائف الشركة",
  T_delete_companyTopic: "حذف موضوع الشركة",
  T_calender: "تقويم",
  T_enrolled_calender: "التقويم المسجل",
  T_title: "عنوان",
  T_internal_id: "الرقم الداخلي",
  T_title_Ar: "عنوان عربي",
  T_description: "وصف",
  T_description_Ar: "وصف عربي",
  T_approve_workshop: "الموافقة على ورشة العمل",
  T_reject_workshop: "ورشة عمل الرفض",
  T_approve_workshop_confirm: "هل أنت متأكد أنك تريد الموافقة على هذه الورشة؟",
  T_reject_workshop_confirm: "هل أنت متأكد أنك تريد رفض هذه الورشة؟",
  T_clone:'نسخ',
  T_corporate_competencies: "الكفاءات المؤسسية",
  T_corporate_topics: "مواضيع الشركات",
  T_corporate_vendors: "البائعين المؤسسيين",
  T_per_page: "لكل صفحة",
  T_add_country: "إضافة دولة",
  T_trainer_bio: "السيرة الذاتية للمدرب",
  T_filter_calender:'تصفية التقويم',
  T_filter_workshops:'تصفية ورش العمل',
  T_add_user: "إضافة مستخدم",
  T_edit_user: "تحرير العضو",
  T_edit_country: "تعديل دولة",
  T_add_venue: "إضافة مكان",
  T_delete_country: "حذف دولة",
  T_enter_name: "أدخل الاسم",
  T_enter_code: "أدخل الرمز",
  T_edit_colors: "تحرير الألوان",
  T_colors_1: "إضافة تحديث لون الأيقونة",
  T_colors_2: "إضافة تحديث لون الأيقونة عند التمرير",
  T_colors_3: "لون زر الإلغاء",
  T_colors_4: "لون زر الإلغاء عند التمرير",
  T_colors_5: "اللون الرئيسي للمخطط",
  T_colors_6: "لون أيقونة الحذف",
  T_colors_7: "لون أيقونة الحذف عند التمرير",
  T_colors_8: "لون الملصق",
  T_colors_9: "لون خلفية القائمة",
  T_colors_10: "لون العنصر في القائمة عند التمرير",
  T_hod:'رئيس القسم',
  T_approving_officer:'موظف الموافقة',
  T_colors_11: "لون العنصر المحدد في القائمة",
  T_colors_12: "لون أيقونة العرض",
  T_colors_13: "لون أيقونة العرض عند التمرير",

  T_add: "إضافة",
  T_save: "حفظ",
  T_cancel: "إلغاء",
  T_code: "رمز",
  T_edit: "تعديل",
  T_delete: "حذف",
  T_delete_country_confirm: "هل أنت متأكد أنك تريد حذف هذه الدولة؟",
  T_delete_vendor_confirm: "هل أنت متأكد أنك تريد حذف هذا البائع؟",
  T_edit_evaluation_question_dimension: "تحرير سؤال التقييم البعد",
  T_delete_evaluation_question_dimension: "حذف بُعد سؤال التقييم",
  T_delete_evaluation_question_dimension_confirm: "هل أنت متأكد أنك تريد حذف هذا البعد من السؤال؟",
  T_delete_competency_confirm: "هل أنت متأكد أنك تريد حذف هذه الكفاءة؟",
  T_add_city: "إضافة مدينة",
  T_gender: "جنس",
  T_edit_city: "تعديل مدينة",
  T_delete_city: "حذف مدينة",
  T_delete_city_confirm: "هل أنت متأكد أنك تريد حذف هذه المدينة؟",
  T_add_workshop_assessment: "إضافة تقييمات ورشة العمل",
  T_add_assessment: "إضافة تقييمات",
  T_edit_assessment: "تعديل التقييم",
  T_delete_assessment: "حذف التقييم",
  T_delete_assessment_Confirm: "هل أنت متأكد أنك تريد حذف هذا التقييم؟",
  T_import: "إستيراد",
  T_create_link:"إنشاء رابط التسجيل",
  T_create_link_success:"تم نسخ رابط التسجيل بنجاح",
  T_download_template: "تحميل نموذج",
  T_companies_included: "الشركات المدرجة",
  T_select_topics: "حدد الموضوع",
  T_select_companies: "اختر الشركات",
  T_city: "مدينة",
  T_add_vendor: "إضافة بائع",
  T_edit_vendor: "تعديل بائع",
  T_delete_vendor: "حذف بائع",
  T_parameters: "المعاملات",
  T_add_parameter: "إضافة معامل",
  T_edit_parameter: "تعديل معامل",
  T_delete_parameter: "حذف معامل",
  T_delete_parameter_confirm: "هل أنت متأكد أنك تريد حذف هذا المعامل؟",
  T_no_parameters: "لا توجد معاملات",
  T_no_parameters_message: "لم يتم العثور على معاملات",
  T_value: "القيمة",
  T_enter_value: "أدخل القيمة",
  T_updated_on: "تم التحديث في",
  T_update: "تحديث",
  T_biography: "سيرة ذاتية",
  T_last_name: "اسم العائلة",
  T_first_name: "الاسم الأول",
  T_consolidation: "توطيد",
  T_middle_name: "الاسم الأوسط",
  T_enter_biography: "أدخل السيرة الذاتية",
  T_proficiency_level: "مستوى الكفاءة",
  T_select_proficiency_level: "حدد مستوى الكفاءة",
  T_no_permissions: "لا يوجد أذونات",
  T_no_permissions_message: "لم يتم العثور على أذونات",
  T_enter_last_name: "إدخال اسم آخر",
  T_delete_permission_confirm: "هل أنت متأكد أنك تريد حذف إذن هذه؟",
  T_role_name: "اسم الدور",
  T_enter_role_name: "أدخل اسم الدور",
  T_enter_first_name: "أدخل الاسم الأول",
  T_workshop_title: "عنوان ورش العمل",
  T_enter_middle_name: "أدخل الاسم الأوسط",
  T_add_trainer: "إضافة مدرب",
  T_to_date: "إلى تاريخ",
  T_from_date: "من تاريخ",
  T_link: "رابط",
  T_capacity: "سعة",
  T_room_number: "رقم الغرفة",
    T_delete_workshop_group: "حذف مجموعة الورشة",
  T_delete_workshop_group_confirm: "هل أنت متأكد أنك تريد حذف مجموعة الورشة هذه؟",
  T_enter_phone_number: "أدخل رقم الهاتف",
  T_enter_email: "أدخل البريد الإلكتروني",
  T_welcome:'مرحباً',
  T_enter_username: "ادخل اسم المستخدم",
  T_topic_number: "رقم الموضوع",
  T_withdrawalDeadline:"الموعد النهائي للانسحاب (أيام)",
    T_no_option_header:"لم يتم العثور على خيارات",
  T_no_option_message:"لا توجد خيارات متاحة",
  T_vendor_name: "اسم البائع",
  T_venue_name: "اسم المكان ",
  T_delete_question: "حذف السؤال",
  T_edit_question: "تعديل السؤال",
  T_delete_question_confirm: "هل أنت متأكد أنك تريد حذف هذا السؤال؟",
  T_trainees_evolution: "تطور المتدربين",
  T_company_name: "اسم الشركة",
  T_file_size: "الحد الأقصى لحجم الملف: 2.5 ميجابايت",
  T_delete_venue: "حذف المكان",
  T_delete_venue_confirm: "هل أنت متأكد أنك تريد حذف هذا المكان؟",
  T_enter_country_code: "أدخل رمز البلد",
  T_add_workshop: "إضافة ورشة عمل",
  T_edit_workshop: "ورشة التحرير",
  T_delete_workshop: "حذف ورشة العمل",
    T_edit_corporate:'تعديل الشركة',
    T_add_corporate:'إضافة الشركة',
  T_delete_corporate:'حذف الشركة',
  T_delete_corporate_confirm:  "هل أنت متأكد أنك تريد حذف هذه الشركة؟",
  T_delete_workshop_confirm: "هل أنت متأكد أنك تريد حذف ورشة العمل هذه؟",
  T_delete_workshop_invitation_confirm:"هل أنت متأكد أنك تريد حذف دعوة مجموعة ورشة العمل هذه؟",
  T_delete_workshop_invitation: "حذف دعوة ورشة العمل",
  T_no_company_header: "لم يتم العثور على شركات",
   T_is_corporate: 'هل هي شركة كبرى ؟',
   T_add_language: "إضافة لغة",
  T_no_company_message: "لا توجد شركات متاحة",
  T_no_city_header: "لم يتم العثور على مدن",
  T_no_city_message: "لا توجد مدن متاحة",
  T_reg: "رقم التسجيل",
  T_number_of_questions:"عدد الأسئلة",
      T_no_language_header: "لا يوجد لغات",
  T_no_language_message:
    "لا توجد لغات متاحة",
  T_no_country_header: "لم يتم العثور على دول",
  T_no_country_message: "لا توجد دول متاحة",
  T_no_vendor_header: "لم يتم العثور على موردين",
  T_no_vendor_message: "لا توجد موردين متاحين",
  T_no_venue_header: "لم يتم العثور على تدريب",
   T_no_invitation_list: "لا توجد قائمة دعوة",
  T_no_invitation_list_message: "لا توجد قائمة دعوات متاحة",
  T_no_venue_message: "لا توجد أماكن  متاحة",
  T_no_training_header: "لم يتم العثور على تدريب",
  T_no_training_message: "لا توجد تدريب متاحة",
  T_no_user_header: "لم يتم العثور على مستخدمين",
  T_no_user_message: "لا توجد مستخدمين متاحين",
  T_timeToComplete:"الوقت لإكمال",
  T_accept: "يقبل",
  T_no_prof_header: "لم يتم العثور على مستويات الكفاءة",
  T_no_prof_message: "لا توجد مستويات الكفاءة المتاحة",
  T_no_competency_header: "لم يتم العثور على كفاءات",
  T_no_competency_message: "لا توجد كفاءات متاحة",
  T_no_topic_header: "لم يتم العثور على مواضيع",
  T_no_topic_message: "لا توجد مواضيع متاحة",
  T_no_workshop_header: "لم يتم العثور على ورش عمل",
  T_no_workshop_message: "لا توجد ورش عمل متاحة",
  T_no_assessments:"لا يوجد تقييم",
  T_no_department_header: "لم يتم العثور على أقسام",
  T_no_department_message: "لا توجد أقسام متاحة",
  T_reset: "اعادة تعيين",
  T_unfinish: "إلغاء الإنهاء",
  T_no_industry_header: "لم يتم العثور على الصناعات",
  T_no_industry_message: "لا توجد صناعات متاحة",
  T_no_job_header: "لم يتم العثور على وظائف",
  T_no_job_message: "لا توجد وظائف متاحة",
  T_no_role_header: "لم يتم العثور على أدوار",
  T_no_role_message: "لا توجد أدوار متاحة",
  T_employee_id: "الرقم الوظيفي",
  T_attendance_frequency:'تردد الحضور',
  T_residence_country: "بلد الإقامة",
  T_select_residence_country: "اختر بلد الإقامة",
  T_select_job: "اختر الوظيفة",
  T_enter_employee_id: "ادخل الرقم الوظيفي",
  T_profile_picture: "صورة الملف الشخصي",
  T_add_vendor_assessment_type: "إضافة نوع التقييم",
  T_edit_vendor_assessment_type: "تعديل نوع التقييم",
  T_delete_vendor_assessment_type: "حذف نوع التقييم",
  T_delete_vendor_assessment_type_confirm: "هل أنت متأكد أنك تريد حذف نوع التقييم هذا؟",
  T_employees: "الموظفون",
  T_add_employee: "اضافة موظف",
  T_select_department: "اختر القسم",
  T_company_departments: "الأقسام",
  T_department_name: "اسم القسم",
  T_no_employee_header: "لا يوجد موظفون",
  T_job: "الوظيفة",
  T_company_jobs: "الوظائف",
  T_company_job_competencies: "مهارات الوظيفة",
  T_competency_name: "اسم المهارة",
  T_no_company_jobs_competencies_header: "لا يوجد مهارات",
  T_no_company_jobs_competencies_message: "لا يوجد مهارات للوظيفة المختارة",
  T_system_parameters: "اعدادات النظام",
  T_security: "أمن النظام",
  T_workshop_invitations_list: "لائحة المدعوين",
  T_acquired_competencies: "الكفاءات المكتسبة",
  T_send_invitations: "ارسال الدعوات",
  T_acquire_source: "مصدر الاستحواذ",
  T_verified: "تم التحقق؟",
  T_employee_competencies: "مهارات الموظف",
  T_no_employee_competency_header: "لا يوجد كفايات",
  T_no_employee_competency_message: "لا يوجد كفايات للموظف",
  T_select_date: "حدد التاريخ",
  T_evaluation: "التقييم",
  T_evaluation_from_date:"من تاريخ التقييم",
  T_evaluation_to_date:"التقييم تاريخ الى",
  T_select_evaluation:"اختر التطور",
  T_attendance_count: "عدد أيام الحضور",
  T_withdraw: "انسحاب",
  T_hello: "مرحبا",
  T_default_name: "الاسم الافتراضي",
  T_custom_name: "الاسم المخصص",
  T_default_name_ar: "الاسم الافتراضي باللغة العربية",
  T_custom_name_ar: "الاسم المخصص باللغة العربية",
  T_rank: "التسلسل",
  T_company_proficiency_levels: "مستويات الكفاءة",
  T_edit_proficiency_level: "تعديل مستوى الكفاءة",
  T_add_proficiency_level: "إضافة مستوى الكفاءة",
  T_delete_proficiency_level: "حذف مستوى الكفاءة",
  T_delete_proficiency_level_confirm: "هل أنت متأكد أنك تريد حذف مستوى الكفاءة هذا؟",
  T_title_ar: "العنوان باللغة العربية",
  T_active: "مفعل",
  T_inactive: "غير مفعل",
  T_minutes: "دقائق",
  T_no_evaluation: "لا يوجد تقييم",
  T_no_evaluation_message: "لم يتم العثور على تقييم لهذه الورشة",
  T_created_date: "تاريخ الانشاء",
  T_workshop_evaluation: "تقييم الدورة",
  T_workshop_evaluation_question_dimensions: "نطاقات أسئلة التقييم",
  T_description_ar: "الوصف باللغة العربية",
  T_is_active: "الحالة",
  T_is_locked:"مغلق",
  T_vendor_assessment_definition: "تعريف التقييمات",
  T_vendor_assessment_questions: "أسئلة التقييم",
  T_vendor_assessment_workshops: "ورش عمل التقييم",
  T_vendor_assessment_question_options: "خيارات أسئلة التقييم",
  T_add_vendor_assessment_question_option: "إضافة خيار أسئلة التقييم",
  T_no_vendor_assessment_questions: "لا يوجد أسئلة تقييم",
  T_assessment_level: "مستوى التقييم",
  T_assessment: "التقييم",
  T_assessment_result: "نتيجة التقييم",
  T_select_assessment: "اختيار التقييم",
  T_detailed_scores: "النتائج التفصيلية",
  T_enrolled: "مُسجَّل",
  T_completed: "مُكتَمِل",
  T_upcoming: "ورش عمل مفتوحة",
  T_minute:'دقيقة',
  T_invitation: "دعوة",
  T_enroll: "التسجيل",
  T_reject: "رفض",
  T_show_assessment: "عرض التقييم",
  T_addition: "الإضافة",
  T_eligibleForCertificate: "مؤهل للشهادة",
  T_employee: "الموظف",
  T_involvement: "المشاركة",
  T_posttestScore: "درجة الاختبار البعدي",
  T_pretestScore: "درجة الاختبار القبلي",
  T_evaluationScore: "درجة التقييم",
  T_employeeGrades: "درجات الموظف",
  T_grading: "التصنيف",
  T_languages: "اللغات",
  T_select_languages: "اختر اللغات",
  T_certifying_bodies: "الهيئات المعتمدة",
  T_certifying_body: "الهيئة المعتمدة",
  T_add_certifying_body: "إضافة هيئة معتمدة",
  T_edit_certifying_body: "تعديل الهيئة المعتمدة",
  T_delete_certifying_body: "حذف الهيئة المعتمدة",
  T_delete_certifying_body_confirm: "هل أنت متأكد أنك تريد حذف هذه الهيئة المعتمدة؟",
  T_no_certifying_bodies: "لا توجد هيئات معتمدة",
  T_none: "لا شيء",
  T_vendor_assessment_type : "أنواع التقييمات",
  T_close: "اغلاق",
  T_prerequisite: "الشرط الأساسي",
  T_enter_prerequisite: "أدخل الشرط الأساسي",
  T_corporate: 'شركة كبرى',
  T_add_to_waiting_list: 'أضِفني إلى قائمة الانتظار',
  T_employee_name: 'اسم الموظف',
  T_send_vouchers: 'إرسال القسائم',
  T_vouchers: 'القسائم',
  T_voucher_code: 'رمز القسيمة',
  T_expiry_date: 'تاريخ الانتهاء',
  T_is_used: 'تم الاستخدام',
  T_sending: 'جارٍ الإرسال...',
  T_no_employees: 'لم يتم العثور على موظفين',
  T_startedOn: 'بدأ في',
  T_elapsedTime: 'الوقت المنقضي',
  T_yes: "نعم",
  T_no: "لا",
  T_questions_answered: "الأسئلة المُجابة",
  T_questionAnswered: 'الأسئلة المُجابة',
  T_monitorAssessment: 'مراقبة التقييم',
  T_monitor: 'مراقبة',
  T_SwitchRole: 'تبديل الدور',
  T_SwitchEntity: 'تبديل الشركة',
  T_reports: "التقارير",
  T_score_data: "بيانات الدرجات",
  T_evaluation_data: "بيانات التقييم",
  T_view_details: 'عرض التفاصيل',
  T_more_actions: "إجراءات إضافية",
  T_questions_analysis_report: "تقرير تحليل الأسئلة",
  T_pretest_grades_report: "تقرير درجات الاختبار التمهيدي",
  T_pretest_analysis_report: "تقرير تحليل الاختبار التمهيدي",
  T_workshop_excel_report: "تقرير ملخص الورشة (Excel)",
  T_workshop_excel_report_success: "تم تنزيل تقرير ملخص الورشة بنجاح.",
  T_workshop_excel_report_failed: "فشل تنزيل تقرير ملخص الورشة.",
  T_workshop_report_pdf: "تقرير الورشة",
  T_workshop_report_success: "تم تنزيل تقرير الورشة بنجاح.",
  T_workshop_report_failed: "فشل تنزيل تقرير الورشة.",
  T_attendees_chronological_report_excel: "تقرير قائمة الحضور (Excel)",
  T_attendees_chronological_report_pdf: "تقرير قائمة الحضور (PDF)",
  T_attendees_chronological_report_success: "تم تنزيل تقرير الحضور الزمني بنجاح.",
  T_attendees_chronological_report_failed: "فشل تنزيل تقرير الحضور الزمني.",
  T_questions_list: "قائمة الأسئلة",
  T_download: "تحميل",
  T_downloading: "جاري التحميل...",
  T_workshops_per_client: "ورش العمل لكل عميل",
  T_select_company: "اختر الشركة",
  T_select: "اختر",
  T_discount: "الخصم",
  T_voucher_discount: "خصم القسيمة",
  T_all: "الكل",
  T_generate_report: "إنشاء التقرير",
  T_export_excel: "تصدير إلى Excel",
  T_export_pdf: "تصدير إلى PDF",
  T_export_to_excel: "تصدير إلى Excel",
  T_export_success: "تم تصدير البيانات بنجاح",
  T_no_data_to_export: "لا توجد بيانات متاحة للتصدير",
  T_topic: "الموضوع",
  T_trainer: "المدرب",
  T_pretest_average: "متوسط الاختبار القبلي",
  T_posttest_average: "متوسط الاختبار البعدي",
  T_evaluation_average: "متوسط التقييم",
  T_enrollment_count: "عدد المسجلين",
  T_enrollment_list: "قائمة الالتحاق",
  T_no_data_available: "لا توجد بيانات متاحة",
  T_workshop_photos: "صور ورشة العمل",
  T_workshop_enrollment: "تسجيل ورشة العمل",
  T_venue: "المكان",
  T_available_seats: "المقاعد المتاحة",
  T_enroll_now: "سجل الآن",
  T_enrolling: "جاري التسجيل...",
  T_already_enrolled: "أنت مسجل بالفعل في هذه الورشة",
  T_go_to_dashboard: "الذهاب إلى لوحة التحكم",
  T_go_to_workshop: "الذهاب إلى الورشة",
  T_enrollment_success: "تم التسجيل في الورشة بنجاح",
  T_enrollment_error: "خطأ في التسجيل في الورشة",
  T_error_fetching_workshop: "خطأ في جلب تفاصيل الورشة",
  T_workshop_not_found: "لم يتم العثور على الورشة",
  T_view_employee_workshops: "عرض ورش الموظف",
  T_employee_workshops: "ورش الموظف",
  T_no_workshops_found: "لم يتم العثور على ورش لهذا الموظف",
  T_global_no_company: "عام (بدون شركة)",
  T_optional: "اختياري",
  T_back_to_assessments: "العودة إلى التقييمات",
  T_import_questions: "استيراد الأسئلة",
  T_view_workshops: "عرض ورش العمل",
  T_view_workshop: "عرض ورشة العمل",
  T_workshops_using_assessment: "ورش العمل المستخدمة للتقييم",
  T_no_workshops_using_assessment: "لا توجد ورش عمل",
  T_no_workshops_using_assessment_message: "هذا التقييم لم يتم استخدامه في أي ورشة عمل بعد",
  T_date_of_workshop: "تاريخ الورشة",
  T_workshop_name: "اسم الورشة",
  T_pre_test_score: "نتيجة الاختبار القبلي",
  T_post_test_score: "نتيجة الاختبار البعدي",
  T_evaluation_score: "نتيجة التقييم",
  T_attendance_percentage: "نسبة الحضور",
  T_certificate_link: "رابط الشهادة"
};
